(() => {
  if (window.ctSystemHeaderReady) return;
  window.ctSystemHeaderReady = true;
  const start = () => {
    const hero = document.querySelector('.ct-system-hero') ||
      (document.body.classList.contains('template-list-collections') && document.querySelector('.ct-page-hero'));
    if (!hero) return;
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const ticker = document.querySelector('.ct-ticker-section');
      const alertHeight = ticker ? Math.max(0, ticker.getBoundingClientRect().height) : 0;
      document.body.style.setProperty('--ct-system-alert-height', `${alertHeight}px`);
      document.body.dataset.ctSystemHeader = hero.getBoundingClientRect().bottom <= alertHeight + 86 ? 'light' : 'image';
    };
    const request = () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
    };
    addEventListener('scroll', request, {passive: true});
    addEventListener('resize', request);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
